var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPikantActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700 0H0V700H700V0ZM495.565 273.389C499.152 278.904 502.044 285.035 504.049 291.745C506.055 298.455 507.173 305.743 507.366 313.495C509.178 393.743 476.13 461.459 414.315 504.147C354.08 545.756 268.934 559.793 202.607 532.953C195.743 530.176 191.771 523.351 192.696 515.985C193.66 508.619 199.213 502.989 206.579 502.025C316.019 487.526 351.612 474.993 372.86 308.018C375.213 289.007 383.426 273.119 395.535 262.052C390.445 237.835 415.973 220.405 443.545 220.675C444.123 214.504 443.121 209.414 440.46 205.481C436.334 199.427 427.927 195.339 416.744 193.951C402.784 192.139 396.19 180.801 398.041 170.158C399.969 159.014 410.497 151.725 421.487 153.615C425.42 154.309 439.843 159.438 447.825 164.952C469.459 178.449 478.019 201.856 471.194 226.613C476.554 229.042 481.413 232.089 485.539 235.752C496.837 245.894 501.773 259.969 495.565 273.389ZM205.538 525.78C267.315 550.807 349.453 539.547 409.957 497.784C469.574 456.638 501.427 391.236 499.654 313.687C498.844 278.75 476.439 254.224 443.931 252.643C410.575 250.908 384.892 273.467 380.496 308.944C359.788 472.063 327.164 493.85 207.582 509.661C202.878 510.316 200.757 513.864 200.371 516.949C199.946 520.073 201.103 524.006 205.538 525.78Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikantActive);
export default __webpack_public_path__ + "static/media/pikant_active.7565613372a9162e58041ce45551f1d8.svg";
export { ForwardRef as ReactComponent };